import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=436441ad&"
import script from "./ServiceList.vue?vue&type=script&lang=js&"
export * from "./ServiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports